import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { QuantitySelect } from 'ui-components/components/quantity-select';
import PropTypes from 'prop-types';

import { MessageDescriptorPropType } from '../../prop-types/intl';
import style from './item-quantity-in-shipments.module.less';

export const EditableSection = ({ editableQuantity, editableText, onEditableQuantityChanged, quantityDone, totalQuantity }) => {
  const quantityTodo = totalQuantity - quantityDone;
  return (
    <div className={classnames(style['editable-section'], style.section)}>
      <div className={style['section-title']}>
        <FormattedMessage {...editableText} />
      </div>
      <div className={style['section-content']}>
        <QuantitySelect
          currentQuantity={editableQuantity}
          maxQuantity={quantityTodo}
          onCurrentQuantityChanged={onEditableQuantityChanged}
        />
      </div>
    </div>
  );
};

EditableSection.propTypes = {
  editableQuantity: PropTypes.number.isRequired,
  editableText: MessageDescriptorPropType.isRequired,
  quantityDone: PropTypes.number.isRequired,
  totalQuantity: PropTypes.number.isRequired,
  onEditableQuantityChanged: PropTypes.func.isRequired,
};
